module.exports = __webpack_public_path__ + "fonts/inter-latin-400-normal.woff2";